<script>
export default {
  props: {
    module: Object,
    span: {
      default: 6,
    },
  },
};
</script>
<template>
  <ColGroup
    label="Оплата"
    :span="span"
    class="p-t-c-itt"
  >
    <el-radio-group v-model="module.type">
      <el-radio-button
        :disabled="module.payer==='agency'"
        label="pay">Оплата онлайн
      </el-radio-button>
      <el-radio-button label="preorder">Оставить заявку</el-radio-button>
    </el-radio-group>
  </ColGroup>
</template>
<style lang="scss">
  .p-t-c-itt {
    .el-radio-group {
      display: flex;
      margin: 8px;
    }

    .el-radio-button {
      width: 50%;
    }

    .el-radio-button__inner {
      width: 100%;
    }
  }
</style>
